import { render, staticRenderFns } from "./FillClaimEditing.vue?vue&type=template&id=52519d20&scoped=true"
import script from "./FillClaimEditing.vue?vue&type=script&lang=js"
export * from "./FillClaimEditing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52519d20",
  null
  
)

export default component.exports